import React, { Component } from "react";
import { Link } from "react-router-dom";
import CESSVG from "../../Assets/svg/CESSVG.svg";
import ChangePasswordImage from "../../Assets/jpeg/OverLay.jpg";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouterHooks } from "../../withRouters/withRoutersHook";
import { ConfirmPasswordAction } from "../../Actions/Authentication";
import { ArrowLeft, ShieldCheck, Eye, EyeOff } from "lucide-react";

class Confirmforgotpassword extends Component {
  state = {
    new_password: "",
    new_password_confirm: "",
    showPassword: false,
    formError: null,
  };

  static propTypes = {
    ConfirmPasswordAction: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    forgotPasswordEmail: PropTypes.string,
    ForgotPasswordOtp: PropTypes.string,
    isPasswordChangedSuccess: PropTypes.bool,
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { new_password, new_password_confirm } = this.state;

    if (new_password !== new_password_confirm) {
      this.setState({ formError: "Passwords do not match." });
      return;
    }

    if (new_password.length < 8) {
      this.setState({ formError: "Password must be at least 8 characters." });
      return;
    }

    this.setState({ formError: null });
    const { ForgotPasswordOtp, forgotPasswordEmail } = this.props;
    this.props.ConfirmPasswordAction(forgotPasswordEmail, ForgotPasswordOtp, new_password);
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  toggleShowPassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isPasswordChangedSuccess &&
      this.props.isPasswordChangedSuccess !== prevProps.isPasswordChangedSuccess
    ) {
      this.props.navigate("/login");
    }
  }

  render() {
    const { new_password, new_password_confirm, showPassword, formError } = this.state;

    return (
      <div className="flex w-full min-h-screen bg-white">

        {/* Left panel */}
        <div className="flex flex-col flex-1 min-h-screen px-8 py-10 lg:px-16">

          {/* Logo */}
          <div className="flex items-center gap-2.5">
            <img src={CESSVG} alt="Logo" className="w-8 h-8" />
            <span className="font-SFPro font-bold text-gray-900 text-lg tracking-tight">CX2 AI</span>
          </div>

          {/* Form */}
          <div className="flex flex-col flex-1 justify-center">
            <div className="w-full max-w-[380px] mx-auto">

              {/* Icon */}
              <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center mb-6">
                <ShieldCheck className="w-6 h-6 text-primary-blue" />
              </div>

              <h1 className="font-SFPro font-bold text-[2rem] leading-tight text-gray-900 mb-2">
                Set new password
              </h1>
              <p className="font-inter text-sm text-gray-400 mb-8">
                Must be at least 8 characters long.
              </p>

              {formError && (
                <div className="flex items-center gap-2 px-4 py-3 mb-6 bg-red-50 border border-red-100 rounded-xl text-sm font-inter text-red-600">
                  {formError}
                </div>
              )}

              <form onSubmit={this.onSubmit} className="flex flex-col gap-4">
                <div className="flex flex-col gap-1.5">
                  <label className="font-inter font-medium text-sm text-gray-700">New password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="new_password"
                      value={new_password}
                      onChange={this.onChange}
                      placeholder="••••••••"
                      required
                      className="w-full h-11 px-4 pr-11 bg-gray-50 border border-gray-200 rounded-xl text-sm font-inter text-gray-900 placeholder-gray-400 outline-none focus:bg-white focus:border-primary-blue transition-all"
                    />
                    <button
                      type="button"
                      onClick={this.toggleShowPassword}
                      className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                    </button>
                  </div>
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="font-inter font-medium text-sm text-gray-700">Confirm new password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="new_password_confirm"
                    value={new_password_confirm}
                    onChange={this.onChange}
                    placeholder="••••••••"
                    required
                    className="w-full h-11 px-4 bg-gray-50 border border-gray-200 rounded-xl text-sm font-inter text-gray-900 placeholder-gray-400 outline-none focus:bg-white focus:border-primary-blue transition-all"
                  />
                </div>

                <button
                  type="submit"
                  disabled={!new_password || !new_password_confirm}
                  className="mt-2 flex items-center justify-center w-full h-11 bg-primary-blue text-white font-inter font-semibold text-sm rounded-xl hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm"
                >
                  Reset password
                </button>
              </form>

              <Link
                to="/login"
                className="flex items-center justify-center gap-2 mt-8 font-inter text-sm text-gray-500 hover:text-gray-700 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                Back to sign in
              </Link>
            </div>
          </div>

          <p className="font-inter text-xs text-gray-300 text-center">
            © {new Date().getFullYear()} CX2 AI. All rights reserved.
          </p>
        </div>

        {/* Right panel */}
        <div className="hidden lg:flex lg:w-[52%] relative overflow-hidden sticky top-0 h-screen">
          <img src={ChangePasswordImage} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#0D6EFD]/60 to-gray-900/70" />
          <div className="relative z-10 flex flex-col justify-end h-full p-12">
            <div className="backdrop-blur-sm bg-white/10 border border-white/20 rounded-2xl p-6 max-w-sm">
              <p className="font-SFPro font-semibold text-white text-lg leading-snug mb-3">
                "Your data is protected with enterprise-grade security."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-white text-xs font-bold">CX</div>
                <div>
                  <p className="font-inter font-medium text-white text-sm">Security Team</p>
                  <p className="font-inter text-white/60 text-xs">Password Reset</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  forgotPasswordEmail: state.authentication?.forgotPasswordEmail,
  ForgotPasswordOtp: state.authentication?.ForgotPasswordOtp,
  isPasswordChangedSuccess: state.authentication?.isPasswordChangedSuccess,
});

export default withRouterHooks(
  connect(mapStateToProps, { ConfirmPasswordAction })(Confirmforgotpassword)
);
